// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Aid_textarea__19Sip"};